import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "d-flex flex-column flex-sm-row justify-content-center align-items-center mt-3 pt-3 border-top w-100" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]

import {onMounted, ref} from 'vue';
import SignaturePad from 'signature_pad';
import {WarningToast} from '@/components/VueToast';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContractSignatureForm',
  props: {
    isSaving: { type: Boolean }
  },
  emits: ["sign"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const canvasRef = ref<HTMLCanvasElement | null>(null);
let signaturePad: SignaturePad | null = null;

function clearSignature() {
  signaturePad?.clear();
}

function submitSignature() {
  if (!signaturePad || signaturePad.isEmpty()) {
    WarningToast('Bitte zeichnen Sie Ihre Unterschrift.');
    return;
  }

  emit('sign', signaturePad.toDataURL('image/png'));
}

onMounted(() => {
  if (canvasRef.value) {
    signaturePad = new SignaturePad(canvasRef.value, {
      backgroundColor: '#fff',
      penColor: 'rgb(0, 0, 0)',
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("small", {
        class: "text-muted d-block text-uppercase fw-bold mb-2",
        style: {"font-size":"11px","letter-spacing":"0.8px"}
      }, [
        _createElementVNode("i", { class: "fa-solid fa-pen-nib me-1 text-primary" }),
        _createTextVNode(" Unterschrift zeichnen ")
      ], -1)),
      _createElementVNode("canvas", {
        ref_key: "canvasRef",
        ref: canvasRef,
        width: "350",
        height: "200",
        style: {"border":"1px solid rgb(208, 208, 208)"}
      }, null, 512)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-soft-red fw-bold me-0 me-sm-3 px-4",
        style: {"min-height":"38px"},
        disabled: __props.isSaving,
        onClick: clearSignature
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("i", { class: "fa-solid fa-eraser me-2" }, null, -1),
        _createTextVNode(" Löschen ", -1)
      ]))], 8, _hoisted_3),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary fw-bold mt-3 mt-sm-0 px-4",
        style: {"min-height":"38px"},
        disabled: __props.isSaving,
        onClick: submitSignature
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("i", { class: "fa-solid fa-signature me-2" }, null, -1),
        _createTextVNode(" Unterschreiben ", -1)
      ]))], 8, _hoisted_4)
    ])
  ], 64))
}
}

})